import request, { merchantApi } from '@/config/axios'

export interface DiyIndustryVO {
  code: string
  industry: string
  name: string
  icon?: string
  sort?: number
  status?: number
}

export interface DiyTemplateVO {
  id?: number
  name: string
  description?: string
  industry: string
  scene: string
  platform: string
  previewImg?: string
  sort?: number
  status?: number
  defaultTemplate?: boolean
  isDefault?: boolean
  applied?: boolean
  isApplied?: boolean
  pageSetting?: string | Record<string, any>
  components?: any[]
  nav?: {
    navConfig?: string
  }
  theme?: string | Record<string, any>
  createTime?: string | Date
  updateTime?: string | Date
}

export interface DiyTemplatePageReqVO {
  pageNo: number
  pageSize: number
  name?: string
  industry?: string
  scene?: string
  status?: number
  applied?: boolean
}

export interface DiyTemplateDraftReqVO {
  templateId: number
  pageSetting: string
  components: Array<Record<string, any>>
  theme: Record<string, any>
  navConfig: string
  promotionConfig?: string
}

export const getIndustryList = async () => {
  const list = await request.get({ url: '/diy/template/industries' })
  return (list || []).map((item: any) => ({
    ...item,
    code: item.code || item.industry,
    industry: item.industry || item.code,
    name: item.name || item.displayName || item.label || item.industry || item.code
  })) as DiyIndustryVO[]
}

export const getDiyTemplatePage = (params: DiyTemplatePageReqVO) => {
  return request.get({ url: '/diy/template/page', params })
}

export const getTemplateGallery = (params: Partial<DiyTemplatePageReqVO>) => {
  return request.get({ url: '/diy/template/gallery', params })
}

export const getDiyTemplate = (id: number) => {
  return request.get({ url: '/diy/template/get', params: { id } })
}

export const getDiyTemplateRenderPreview = (templateId: number) => {
  return merchantApi.get({
    url: '/app-api/diy/template/render/by-template',
    params: { templateId, platform: 'h5' },
    // C 端渲染预览是公开接口，不能将管理端令牌带到 member 认证链路。
    headers: { isToken: false } as any
  })
}

export const createDiyTemplate = (data: Partial<DiyTemplateVO>) => {
  return request.post({ url: '/diy/template/create', data })
}

export const updateDiyTemplate = (data: Partial<DiyTemplateVO>) => {
  return request.put({ url: '/diy/template/update', data })
}

export const saveDiyTemplateDraft = (data: DiyTemplateDraftReqVO) => {
  return request.post({ url: '/diy/template/save-draft', data })
}

export const publishDiyTemplate = (id: number) => {
  return request.post({ url: '/diy/template/publish', params: { id } })
}

export const offlineDiyTemplate = (id: number) => {
  return request.post({ url: '/diy/template/offline', params: { id } })
}

export const applyDiyTemplate = (id: number) => {
  return request.put({ url: '/diy/template/apply', params: { id } })
}

export const deleteDiyTemplate = (id: number) => {
  return request.delete({ url: '/diy/template/delete', params: { id } })
}

export const applyTemplate = (sourceTemplateId: number, targetTemplateId: number) => {
  return request.post({
    url: '/diy/template/apply',
    data: {
      sourceTemplateId,
      targetTemplateId
    }
  })
}
